<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="仓位信息"
    width="1000px"
    class="adaptationModal"
  >
    <table v-if="columns.length" v-loading="contentLoading" class="normalTable" border="1" cellspacing="0">
      <tr>
        <td v-for="item in columns">{{ item }}</td>
      </tr>
      <tr v-for="item in dataSource">
        <td v-for="i in item">{{ i.name }}</td>
      </tr>
    </table>
    <div v-else style="text-align: center">暂无仓位信息</div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      contentLoading: false,
      columns: [],
      dataSource: [],
    };
  },

  methods: {
    open(wareHouseNo) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.getLocations(wareHouseNo);
      });
    },

    getLocations(wareHouseNo) {
      this.contentLoading = true;
      this.$http
        .get("basic", `warehouseLocations/kingdee?warehouseNo=${wareHouseNo}`)
        .then((res) => {
          if (res.success) {
            this.columns = res.data.flexName;
            this.dataSource = res.data.data;
          }
          this.contentLoading = false;
        })
        .cathc(() => {
          this.contentLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.normalTable {
  width: 100%;
  border-color: #e8eaec;
  tr {
    td {
      padding: 6px;
      width: 50%;
    }
    &:first-child {
      font-weight: 700;
      background-color: #f8f8f9;
    }
  }
}
</style>
